var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"help-icon"},[_c('i',{staticClass:"fa fa-question-circle mr-1",attrs:{"id":_vm.uniqueId,"aria-hidden":"true"}}),_vm._v(" "),_c('help-tooltip',_vm._b({attrs:{"target":_vm.uniqueId}},'help-tooltip',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }